exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-list-group__activator p{margin-bottom:0}", ""]);

// exports
